/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ESearchFilter,
  EntityNotFoundErrorDetailsErrorResponseModel,
  SortDirection,
  UserWithRolesDtoPagedResponseDto,
} from '../models/index';
import {
    ESearchFilterFromJSON,
    ESearchFilterToJSON,
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
    UserWithRolesDtoPagedResponseDtoFromJSON,
    UserWithRolesDtoPagedResponseDtoToJSON,
} from '../models/index';

export interface UsersConfirmUserEmailPUTRequest {
    userId?: string;
}

export interface UsersGetUsersOverviewGETRequest {
    searchSearch?: string;
    searchSearchValue?: string;
    searchSearchFilter?: ESearchFilter;
    pagingPageIndex?: number;
    pagingPageSize?: number;
    sortingSortBy?: string;
    sortingSortDir?: SortDirection;
}

export interface UsersResendConfirmationEmailPUTRequest {
    userId?: string;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * Creates request options for usersConfirmUserEmailPUT without sending the request
     * @param {string} [userId] 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersConfirmUserEmailPUTRequestOpts(requestParameters: UsersConfirmUserEmailPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersConfirmUserEmailPUTRaw(requestParameters: UsersConfirmUserEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    usersConfirmUserEmailPUT(requestParameters: UsersConfirmUserEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for usersGetUsersOverviewGET without sending the request
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersGetUsersOverviewGETRequestOpts(requestParameters: UsersGetUsersOverviewGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersGetUsersOverviewGETRaw(requestParameters: UsersGetUsersOverviewGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDtoPagedResponseDto>>;

    /**
     */
    usersGetUsersOverviewGET(requestParameters: UsersGetUsersOverviewGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDtoPagedResponseDto>;

    /**
     * Creates request options for usersResendConfirmationEmailPUT without sending the request
     * @param {string} [userId] 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersResendConfirmationEmailPUTRequestOpts(requestParameters: UsersResendConfirmationEmailPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersResendConfirmationEmailPUTRaw(requestParameters: UsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    usersResendConfirmationEmailPUT(requestParameters: UsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     * Creates request options for usersConfirmUserEmailPUT without sending the request
     */
    async usersConfirmUserEmailPUTRequestOpts(requestParameters: UsersConfirmUserEmailPUTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Users/confirm-email`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async usersConfirmUserEmailPUTRaw(requestParameters: UsersConfirmUserEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersConfirmUserEmailPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async usersConfirmUserEmailPUT(requestParameters: UsersConfirmUserEmailPUTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersConfirmUserEmailPUTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for usersGetUsersOverviewGET without sending the request
     */
    async usersGetUsersOverviewGETRequestOpts(requestParameters: UsersGetUsersOverviewGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['searchSearch'] != null) {
            queryParameters['Search.Search'] = requestParameters['searchSearch'];
        }

        if (requestParameters['searchSearchValue'] != null) {
            queryParameters['Search.SearchValue'] = requestParameters['searchSearchValue'];
        }

        if (requestParameters['searchSearchFilter'] != null) {
            queryParameters['Search.SearchFilter'] = requestParameters['searchSearchFilter'];
        }

        if (requestParameters['pagingPageIndex'] != null) {
            queryParameters['Paging.PageIndex'] = requestParameters['pagingPageIndex'];
        }

        if (requestParameters['pagingPageSize'] != null) {
            queryParameters['Paging.PageSize'] = requestParameters['pagingPageSize'];
        }

        if (requestParameters['sortingSortBy'] != null) {
            queryParameters['Sorting.SortBy'] = requestParameters['sortingSortBy'];
        }

        if (requestParameters['sortingSortDir'] != null) {
            queryParameters['Sorting.SortDir'] = requestParameters['sortingSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Users/overview`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async usersGetUsersOverviewGETRaw(requestParameters: UsersGetUsersOverviewGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDtoPagedResponseDto>> {
        const requestOptions = await this.usersGetUsersOverviewGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersGetUsersOverviewGET(requestParameters: UsersGetUsersOverviewGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDtoPagedResponseDto> {
        const response = await this.usersGetUsersOverviewGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersResendConfirmationEmailPUT without sending the request
     */
    async usersResendConfirmationEmailPUTRequestOpts(requestParameters: UsersResendConfirmationEmailPUTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Users/resend-confirmation`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async usersResendConfirmationEmailPUTRaw(requestParameters: UsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersResendConfirmationEmailPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async usersResendConfirmationEmailPUT(requestParameters: UsersResendConfirmationEmailPUTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersResendConfirmationEmailPUTRaw(requestParameters, initOverrides);
    }

}
